import { z } from 'zod';

export const createUserSchema = z.object({
  email: z.email('Invalid email address'),
  firstName: z.string().min(1, 'First name is required').max(100, 'First name too long'),
  lastName: z.string().min(1, 'Last name is required').max(100, 'Last name too long'),
  phone: z.string().optional().refine(
    (val) => !val || !isNaN(Number(val)),
    'Phone must be a valid number'
  ),
  profileImage: z.url('Invalid URL format').optional().or(z.literal('')),
});

export type CreateUserFormData = z.infer<typeof createUserSchema>;

export type CreateUserResponse = {
  user: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    phone?: number;
    profileImage?: string;
    status: string;
    verified: boolean;
  };
  password: string;
};
